class BlockGallery {
	constructor() {
		jQuery(".block-gallery .gallery").lightGallery();
	}
}
